import {VerifyService} from "../../service/VerifyService";
import {useSubmit} from "../../hooks/submit/useSubmit";
import {useStepCheck} from "../../hooks/stepcheck/useStepCheck";
import {useState} from "react";

export const DataConsentViewModel = (verificationId: string | undefined) => {

    const { submit } = useSubmit(verificationId)
    const { evaluateUrl } = useStepCheck(verificationId)

    const [loading, setLoading] = useState(false)

    const onSubmit = () => {
        submit(giveConsent)
    }

    const giveConsent = async () => {
        setLoading(true)
        if (verificationId) {
            await VerifyService.getInstance().giveConsent(verificationId)
            await evaluateUrl()
        }
        setLoading(false)
    }

    return {
        loading,
        onSubmit
    }
}